import { EmptyStateIllustration } from "shared/components/illustrations/EmptyStateIllustration";
import { Text } from "shared/components/Spor";
import { SectionStateContentSize } from "shared/components/states/SectionStateContent";
import { StateContentContainer } from "shared/components/states/StateContentContainer";
import { GhostIcon } from "shared/icons/GhostIcon";
import { useTheme } from "styled-components";

type EmptyProps = {
  backgroundColor?: string;
  size?: SectionStateContentSize;
  reason: string;
};

const Content = ({
  size,
  reason,
}: {
  size: SectionStateContentSize;
  reason: string;
}) => {
  const theme = useTheme();
  if (size === "sm") {
    return (
      <>
        <GhostIcon size={24} />
        <Text variant="sm" color="text.subtle">
          {reason}
        </Text>
      </>
    );
  }

  if (size === "lg") {
    return (
      <>
        <EmptyStateIllustration height={200} width={200} />
        <Text
          my={0}
          textAlign="center"
          variant="ml"
          color={theme.colorTextSporDefault}
        >
          {reason}
        </Text>
      </>
    );
  }

  /* md */
  return (
    <>
      <GhostIcon size={24} />
      <Text textAlign="center" variant="sm" color="text.subtle">
        {reason}
      </Text>
    </>
  );
};

export const EmptyContent = ({
  backgroundColor,
  size = "md",
  reason,
}: EmptyProps) => (
  <StateContentContainer size={size} backgroundColor={backgroundColor}>
    <Content size={size} reason={reason} />
  </StateContentContainer>
);
